import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitoahmednagarcab() {



  const cardData = {
    keyword: " Mumbai to Ahmednagar Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Ahmednagar cab services, ensuring a smooth, safe, and convenient journey for families, business travelers, students, and long-distance commuters. Whether you are planning a work trip, family visit, or a weekend travel, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Ahmednagar route covers approximately 120 to 130 km and takes around 3 to 4 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Ahmednagar travel.",

"topPlaces": [
  {
    "title": "Cavalry Tank Museum",
    "description": "The Cavalry Tank Museum in Ahmednagar is India’s first and only tank museum, showcasing a wide collection of vintage tanks, armored vehicles, and military equipment. Visitors can explore exhibits related to the Indian Army’s history and evolution of armored warfare. It is a must-visit destination for defense enthusiasts and history lovers."
  },
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort is a historic military fort built during the Nizam Shahi dynasty and later used by the British. It played an important role in India’s freedom struggle, including the imprisonment of Jawaharlal Nehru. The fort offers strong architecture, historical significance, and guided exploration opportunities."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur is one of the most famous religious villages in Maharashtra dedicated to Lord Shani. Known for its unique tradition of houses without doors, it attracts millions of devotees seeking protection and blessings from Lord Shani."
  },
  {
    "title": "Meherabad",
    "description": "Meherabad is a spiritual retreat and the resting place of the revered spiritual master Meher Baba. It is known for its peaceful atmosphere, meditation center, and global followers who visit for spiritual learning and reflection."
  },
  {
    "title": "Rehekuri Blackbuck Sanctuary",
    "description": "Rehekuri Blackbuck Sanctuary is a protected wildlife area near Ahmednagar known for its population of blackbucks and other wildlife species. It offers nature trails, birdwatching, and a calm environment for eco-tourism."
  },
  {
    "title": "Cannon Hill",
    "description": "Cannon Hill is a historical viewpoint in Ahmednagar featuring old cannons and panoramic views of the city. It is a peaceful spot for photography and exploring colonial-era remnants."
  },
  {
    "title": "Salabat Khan Tomb",
    "description": "Salabat Khan Tomb is a beautiful stone structure built in the 16th century, located on a hilltop offering scenic views of Ahmednagar. Its unique architecture and sunset views make it a popular tourist attraction."
  },
  {
    "title": "Bhandardara (Nearby Getaway)",
    "description": "Bhandardara is a scenic hill station located near Ahmednagar, famous for Arthur Lake, Randha Falls, and lush green surroundings. It is a perfect weekend getaway for nature lovers and campers."
  },
  {
    "title": "Anand Dham Ashram",
    "description": "Anand Dham Ashram is a peaceful spiritual center near Ahmednagar offering meditation, yoga, and a calm environment for seekers of inner peace."
  },
  {
    "title": "Mula Dam",
    "description": "Mula Dam is a large irrigation dam near Ahmednagar offering scenic water views, birdwatching opportunities, and a relaxing environment ideal for short trips and photography."
  }
],







services: [
  {
    name: "Mumbai to Ahmednagar Cab",
    description: "Mumbai to Ahmednagar cab service offers a smooth and comfortable journey to one of Maharashtra’s important historical and industrial cities. The route provides a mix of highway travel and scenic surroundings, making the trip pleasant. Ideal for families, business travelers, and tourists, this service ensures safe and timely travel. Professional drivers and well-maintained vehicles enhance comfort. Customers can choose from sedan, SUV, and luxury options. It guarantees a reliable and hassle-free journey."
  },
  {
    name: "Mumbai to Ahmednagar Taxi",
    description: "Mumbai to Ahmednagar taxi provides convenient and private transportation with door-to-door pickup and drop. This service is ideal for travelers seeking a comfortable and flexible ride. Vehicles are clean and driven by experienced chauffeurs. Suitable for personal and business travel. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Ahmednagar Cab Service",
    description: "Mumbai to Ahmednagar cab service is designed for long-distance travel with a focus on safety and comfort. This service is ideal for family trips, corporate travel, and tourism. Vehicles are maintained for highway performance. Professional drivers ensure smooth driving. Flexible pickup options across Mumbai enhance convenience. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Ahmednagar Taxi Service",
    description: "Mumbai to Ahmednagar taxi service offers reliable intercity travel for all types of travelers. Clean vehicles and trained drivers ensure a comfortable journey. Flexible scheduling allows easy trip planning. Door-to-door service adds convenience. It guarantees a pleasant travel experience."
  },
  {
    name: "Cab from Mumbai to Ahmednagar",
    description: "Cab from Mumbai to Ahmednagar provides a personalized travel experience with flexible stops along the route. Travelers can enjoy a comfortable and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Ahmednagar",
    description: "Taxi from Mumbai to Ahmednagar offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, this service ensures smooth highway travel. Door-to-door pickup and drop add convenience. Suitable for short and long trips. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Ahmednagar Cab Booking",
    description: "Mumbai to Ahmednagar cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and travel time. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Ahmednagar Taxi Booking Online",
    description: "Mumbai to Ahmednagar taxi booking online provides a quick and convenient way to book your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Ahmednagar Cab Price",
    description: "Mumbai to Ahmednagar cab price varies based on vehicle type, trip type, and travel timing. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Ahmednagar Taxi Fare",
    description: "Mumbai to Ahmednagar taxi fare is designed to be affordable and competitive for intercity travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Ahmednagar One Way Cab",
    description: "Mumbai to Ahmednagar one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Ahmednagar Round Trip Taxi",
    description: "Mumbai to Ahmednagar round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family visits and business trips. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Ahmednagar Innova Cab",
    description: "Mumbai to Ahmednagar Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance journeys. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Ahmednagar Ertiga Cab",
    description: "Mumbai to Ahmednagar Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Ahmednagar Sedan Cab",
    description: "Mumbai to Ahmednagar sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Ahmednagar SUV Taxi",
    description: "Mumbai to Ahmednagar SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Ahmednagar Cab",
    description: "Cheap Mumbai to Ahmednagar cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Ahmednagar Taxi Service",
    description: "Best Mumbai to Ahmednagar taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Ahmednagar Cab", "Mumbai to Ahmednagar Taxi"],
  ["Mumbai to Ahmednagar Cab Service", "Mumbai to Ahmednagar Taxi Service"],
  ["Cab from Mumbai to Ahmednagar", "Taxi from Mumbai to Ahmednagar"],
  ["Mumbai to Ahmednagar Cab Booking", "Mumbai to Ahmednagar Taxi Booking Online"],
  ["Mumbai to Ahmednagar Cab Price", "Mumbai to Ahmednagar Taxi Fare"],
  ["Mumbai to Ahmednagar One Way Cab", "Mumbai to Ahmednagar Round Trip Taxi"],
  ["Mumbai to Ahmednagar Innova Cab", "Mumbai to Ahmednagar Ertiga Cab"],
  ["Mumbai to Ahmednagar Sedan Cab", "Mumbai to Ahmednagar SUV Taxi"],
  ["Cheap Mumbai to Ahmednagar Cab", "Best Mumbai to Ahmednagar Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ahmednagar Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Ahmednagar cab service, ideal for family visits, business trips, and outstation travel."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Ahmednagar routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Ahmednagar cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Ahmednagar travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Ahmednagar cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Ahmednagar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Ahmednagar for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Ahmednagar?", answer: "The distance is approximately 250 to 280 km and takes around 5 to 7 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ahmednagar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel seasons." },
  { question: "Do you offer same-day return trips?", answer: "Yes, we provide same-day return cab services for Mumbai to Ahmednagar trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sunil Pawar",
    feedback: "Traveling from Mumbai to Ahmednagar with Royal Route Cabs was a smooth experience. The cab arrived on time and the journey was very comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Kulkarni",
    feedback: "Very reliable service for our Mumbai to Ahmednagar trip. The car was clean, and the driver ensured a safe and pleasant ride till the destination.",
    rating: 5
  }
];






















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ahmednagar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-ahmednagar-cab.jpg", // replace if needed
  "description": "Book Mumbai to Ahmednagar cab with Royal Route Cabs for a safe, comfortable, and affordable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-ahmednagar-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Ahmednagar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Ahmednagar cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to ahmednagar cab, mumbai to ahmednagar taxi, mumbai to ahmednagar cab service, mumbai to ahmednagar taxi service, cab from mumbai to ahmednagar, taxi from mumbai to ahmednagar, mumbai to ahmednagar cab booking, mumbai to ahmednagar taxi booking online, mumbai to ahmednagar cab price, mumbai to ahmednagar taxi fare, mumbai to ahmednagar one way cab, mumbai to ahmednagar round trip taxi, mumbai to ahmednagar innova cab, mumbai to ahmednagar ertiga cab, mumbai to ahmednagar sedan cab, mumbai to ahmednagar suv taxi, cheap mumbai to ahmednagar cab, best mumbai to ahmednagar taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoahmednagarcab;